/* Stanbarry Gravur + Bundle & Save – ein Code-Stand für alle Stores (Texte über ui_strings, Daten über Produkt-Metafields).
   Kaufbox aus sb-Bausteinen (STYLEGUIDE.md): ① Farbe = Theme-Swatches, ② Größe = sb-nums (steuert die ausgeblendete
   Theme-Option), ③ Gravur = sb-field + sb-font (Schriften je Produkt), ④ Set = sb-tiers--row (Modus „stufen“) oder
   Knopf „Weiteren Ring hinzufügen“ (Modus „plus“, custom.bundle_modus) + je weiterem Teil eine aufklappbare sb-part-Karte
   mit eigener Farbe, Größe und Gravur (immer nur eine Karte offen, §4.10).
   Modus „anzahl“ (wie SB200, Template-Parameter): Anzahl als Zahlen-Kacheln, Set-Preis im Theme-Preis oben, je Teil ein
   Gravurfeld untereinander mit einer Schriftwahl für alle; Farbe/Größe des Theme-Pickers gelten für alle Teile, keine Vorschau.
   Modus „hybrid“ (= „anzahl“ + cfg.perPart): nur Anzahl → „Deine Ringe“, jedes Teil gleich (Name, Farbe, Größe). Der Theme-Picker
   ist ausgeblendet, Teil 1 stellt ihn; mit cfg.pvButton je Teil ein Knopf „Vorschau“ neben der Größe (Gravur auf dem Einzelring-Foto); ab Teil 2 vorbelegt mit Teil 1, eine Änderung gilt nur für dieses Teil und diese Option.
   Teil 1 geht über das Theme-Formular in den Warenkorb, die weiteren vorher per /cart/add.js – jedes Teil eine eigene
   Position mit eigener Variante. Den Set-Preis macht je Stufe ein automatischer Rabatt (README). */
(() => {
'use strict';
const root = document.querySelector('[data-bundle-engraving]');
if (!root || root.dataset.beInit) return;
root.dataset.beInit = '1';
const cfg = JSON.parse(root.querySelector('.be-config').textContent), T = cfg.t, P = cfg.props;
const origFetch = window.fetch.bind(window);
const variants = cfg.variants, ids = new Set(variants.map(v => String(v.id)));
const tiers = cfg.tiers.filter(t => t.qty > 1).sort((a, b) => a.qty - b.qty);
const maxQty = tiers.length ? tiers[tiers.length - 1].qty : 1;
const [U1, UN, U1lc, UNlc] = cfg.unit, MODE = ['plus', 'anzahl'].includes(cfg.mode) ? cfg.mode : 'stufen';
const U = {unit: U1, units: UN, unitlc: U1lc || U1, unitslc: UNlc || UN};
const FONTS = Object.fromEntries(Object.entries(T.fonts || {}).filter(([, v]) => v));   // Reihenfolge aus custom.gravurschriften, erste = Vorauswahl
const FONT0 = Object.keys(FONTS)[0] || 'script';
const fmt = (s, o) => String(s).replace(/\[(\w+)\]/g, (m, k) => o[k] != null ? o[k] : m);
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
const sec = root.closest('.shopify-section') || document;
const bundle = root.querySelector('[data-be-bundle]'), partsBox = root.querySelector('[data-be-parts]'), nudge = root.querySelector('[data-be-nudge]');
const addBtn = root.querySelector('[data-be-add]');   // nur Modus „plus“
const fieldsBox = root.querySelector('[data-be-fields]'), gTitle = root.querySelector('[data-be-gtitle]');   // nur Modus „anzahl“
const PER = MODE === 'anzahl' && !!cfg.perPart;   // „hybrid“: Farbe/Größe je Teil
const PVBTN = PER && !!cfg.pvButton;   // „hybrid“ + vorschau: true – Vorschau je Teil auf Knopfdruck
const PVHOLD = PVBTN && !!cfg.pvHold;   // vorschau: 'halten' – nur solange der Knopf gedrückt ist, unter der Zeile
const state = {qty: 1, lastFont: FONT0, open: -1,
  parts: [...Array(Math.max(1, maxQty))].map(() => ({name: '', font: null, opts: null, touched: false, err: ''}))};

// ------------------------------------------------------------ Optionen
const values = cfg.options.map((_, k) => [...new Set(variants.map(v => v.options[k]))]);
const colorIdx = cfg.colorOption ? cfg.options.indexOf(cfg.colorOption) : -1;
const sizeIdx = cfg.sizeOption ? cfg.options.indexOf(cfg.sizeOption) : -1;
const findVariant = opts => opts && variants.find(v => v.options.every((o, k) => o === opts[k]));
function swatchAttr(val) {   // Farbe/Bild aus dem Shopify-Swatch des Werts, sonst Token-Klasse
  const s = (cfg.swatches || {})[val];
  if (s && s.image) return {cls: '', style: `--sb-sw-bg:url('${String(s.image).replace(/'/g, '%27')}')`};
  if (s && s.color) return {cls: '', style: `--sb-sw-bg:${s.color}`};
  const cls = /gold|goud|\boro\b|^or$|guld/i.test(val) ? 'gold' : /silver|silber|zilver|argent|plata/i.test(val) ? 'silver' : /ros/i.test(val) ? 'rosegold' : /black|schwarz|zwart|noir|negro|svart/i.test(val) ? 'black' : '';
  return {cls: cls ? ' sb-swatch--' + cls : '', style: ''};
}

// ------------------------------------------------------------ Gravur-Vorschau auf dem Produktfoto (STYLEGUIDE §4.8b)
// custom.gravur_vorschau (alles relativ zur Bildbreite/-höhe): {bilder: {<Farbwert>: url}, kante: [cx, cy, a, b] = Unterkante des
// Bands als Ellipse (gemessen), oben/unten: Gravurzone als Abstand über der Kante, schrift: Normalgröße, breite: max. Textbreite,
// ausschnitt: [x0, y0, x1, y1], farbe}. Text wird an seiner Tintenhöhe in die Zone eingepasst und spaltenweise auf die Kurve gesetzt.
const PV = (MODE !== 'anzahl' || PVBTN) && cfg.preview && cfg.preview.bilder && cfg.preview.kante ? cfg.preview : null;
const PV_EXAMPLE = String(T.placeholder || '').trim().split(/\s+/).pop() || 'Emma';   // ohne Namen: Beispielname aus dem Platzhalter
const FONT_CSS = {typewriter: ['400', '"American Typewriter","SB Cutive",Georgia,serif', 0.05],
                  script: ['400', '"SB Great Vibes",cursive', 0], clean: ['500', '"SB Montserrat",Arial,sans-serif', 0]};
const pvImgs = {};
function pvImage(color) {
  const url = PV && (PV.bilder[color] || Object.values(PV.bilder)[0]); if (!url) return null;
  if (!pvImgs[url]) { const im = new Image(); im.decoding = 'async'; im.onload = () => drawAll(); im.src = url; pvImgs[url] = im; }
  return pvImgs[url];
}
let pvRaf = 0;
function drawAll() { if (!PV) return; cancelAnimationFrame(pvRaf); pvRaf = requestAnimationFrame(() => { for (let i = 0; i < state.qty; i++) drawPv(i); }); }
// Text gerade zeichnen (mit Buchstabenabstand, auch ohne ctx.letterSpacing) – liefert Tintenmaße
function ctxFont(ctx, f, px) { ctx.font = `${f[0]} ${px}px ${f[1]}`; if ('letterSpacing' in ctx) ctx.letterSpacing = `${f[2] * px}px`; }
function inkOf(ctx, f, px, text) {
  ctxFont(ctx, f, px);
  const m = ctx.measureText(text), manual = f[2] && !('letterSpacing' in ctx);
  const extra = manual ? f[2] * px * Math.max(0, [...text].length - 1) : 0;
  return {asc: m.actualBoundingBoxAscent, desc: m.actualBoundingBoxDescent, left: m.actualBoundingBoxLeft, w: m.actualBoundingBoxLeft + m.actualBoundingBoxRight + extra, manual};
}
function fillSpaced(ctx, f, px, text, x, y, manual) {
  if (!manual) { ctx.fillText(text, x, y); return; }
  for (const ch of text) { ctx.fillText(ch, x, y); x += ctx.measureText(ch).width + f[2] * px; }
}
function drawPv(i) {
  const box = partEl(i), wrap = box && box.querySelector('[data-be-pv]'); if (!wrap) return;
  let text = state.parts[i].name.trim();
  if (PVBTN) { if (wrap.hidden) return; text = text || PV_EXAMPLE; }   // Knopf „Vorschau“ öffnet/schließt
  else { wrap.hidden = !text; if (!text) return; }   // erst sichtbar, sobald etwas eingegeben ist
  const o = i === 0 ? (mainVariant() || {}).options : state.parts[i].opts;
  const im = pvImage(o && colorIdx >= 0 ? o[colorIdx] : null); if (!im || !im.complete || !im.naturalWidth) return;
  const f = FONT_CSS[fontOf(i)] || FONT_CSS.typewriter;
  if (document.fonts && !document.fonts.check(`${f[0]} 20px ${f[1]}`)) document.fonts.load(`${f[0]} 20px ${f[1]}`).then(drawAll, () => {});
  const cv = wrap.querySelector('canvas'), dpr = Math.min(2, window.devicePixelRatio || 1);
  const W = Math.round(wrap.clientWidth * dpr), H = Math.round(wrap.clientHeight * dpr); if (!W || !H) return;
  if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
  const x = cv.getContext('2d'), NW = im.naturalWidth, NH = im.naturalHeight;
  const [ax0, ay0, ax1, ay1] = PV.ausschnitt || [0, 0, 1, 1];
  let sx = ax0 * NW, sy = ay0 * NH, sw = (ax1 - ax0) * NW, sh = (ay1 - ay0) * NH;
  const R = PVBTN ? 5 / 3 : W / H;   // Knopf-Vorschau: Zoom und Breite wie die große Vorschau (5:3) …
  if (sw / sh > R) { const nw = sh * R; sx += (sw - nw) / 2; sw = nw; } else { const nh = sw / R; sy += (sh - nh) / 2; sh = nh; }
  if (PVBTN) {   // … davon nur ein Streifen in Kastenhöhe: Band vorn, Gravurzone bei 55 % der Höhe (wie Adnans Zuschnitt)
    const nh = sw * H / W, zMid = (PV.kante[1] + PV.kante[3] - (PV.oben + PV.unten) / 2) * NH;
    sy = zMid - nh * 0.55; sh = nh;
  }
  const k = W / sw;
  x.globalCompositeOperation = 'source-over'; x.globalAlpha = 1;
  x.fillStyle = '#fff'; x.fillRect(0, 0, W, H);
  x.drawImage(im, sx, sy, sw, sh, 0, 0, W, H);
  // Unterkante des Bands (Ellipse) und Gravurzone darüber, in Canvas-Pixeln
  const [ecx0, ecy0, ea0, eb0] = PV.kante, ecx = (ecx0 * NW - sx) * k, ecy = (ecy0 * NH - sy) * k, ea = ea0 * NW * k, eb = eb0 * NH * k;
  const edge = X => { const t = (X - ecx) / ea; return ecy + eb * Math.sqrt(Math.max(0, 1 - t * t)); };
  const z0 = PV.oben * NH * k, z1 = PV.unten * NH * k, inset = (z0 - z1) * 0.04;   // 4 % Sicherheitsrand (Kantenglättung)
  const zTop = z0 - inset, zBot = z1 + inset, zH = zTop - zBot;
  // Größe: Normalgröße, aber Tinte (inkl. Ober-/Unterlängen) passt in die Zone und in die max. Breite
  const off = document.createElement('canvas'), ox = off.getContext('2d');
  const r = inkOf(ox, f, 100, text); if (!(r.asc + r.desc > 0) || !(r.w > 0)) return;
  const px = Math.min(PV.schrift * NH * k, 100 * zH / (r.asc + r.desc), 100 * PV.breite * NW * k / r.w), s = px / 100;
  const inkW = r.w * s, inkH = (r.asc + r.desc) * s, pad = 3;
  off.width = Math.ceil(inkW + 2 * pad); off.height = Math.ceil(inkH + 2 * pad);
  const m2 = inkOf(ox, f, px, text);
  ox.fillStyle = PV.farbe || '#1c1917'; ox.textBaseline = 'alphabetic';
  fillSpaced(ox, f, px, text, pad + m2.left, pad + m2.asc, m2.manual);
  // Spaltenweise auf die Kurve: Bogenlänge u um die Mitte -> X = cx + a·sin(u/a); senkrecht mittig in der Zone
  const half = inkW / 2, Xl = Math.floor(ecx + ea * Math.sin(-half / ea)), Xr = Math.ceil(ecx + ea * Math.sin(half / ea));
  const uOf = X => ea * Math.asin(Math.max(-1, Math.min(1, (X - ecx) / ea)));
  x.globalAlpha = 0.9; x.globalCompositeOperation = 'multiply';
  for (let X = Xl; X < Xr; X++) {
    const u0 = uOf(X) + half + pad, u1 = uOf(X + 1) + half + pad;
    if (u1 <= pad || u0 >= pad + inkW) continue;
    const top = edge(X + 0.5) - zTop + (zH - inkH) / 2 - pad;
    x.drawImage(off, u0, 0, Math.max(0.01, u1 - u0), off.height, X, top, 1.02, off.height);
  }
  x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
}
window.addEventListener('resize', () => drawAll());

// ------------------------------------------------------------ Modus „anzahl“: Galeriebild zur Anzahl (custom.anzahl_bilder)
// {Farbwert: [Media-ID 1 Ring, 2 Ringe, …]}. Nur das Bild der gewählten Anzahl/Farbe bleibt sichtbar und steht vorn (Theme-Galerie:
// data-media-id / data-target = <Section>-<Media-ID>); die Seite wird dabei nicht gescrollt. Die Startlage setzt schon das Snippet.
const STACK = MODE === 'anzahl' && cfg.stack && typeof cfg.stack === 'object' ? cfg.stack : null;
const STACK_IDS = new Set(STACK ? Object.values(STACK).flat().map(String) : []);
let stackCur = '';
function showStack() {
  const gal = STACK && sec.querySelector('media-gallery'); if (!gal) return;
  const v = mainVariant(), list = (v && colorIdx >= 0 && STACK[v.options[colorIdx]]) || Object.values(STACK)[0] || [];
  const cur = String(list[Math.min(state.qty, list.length) - 1] || ''); if (!cur) return;
  let moved = false;
  gal.querySelectorAll('[data-media-id], [data-target]').forEach(el => {
    const id = String(el.dataset.mediaId || el.dataset.target).split('-').pop(); if (!STACK_IDS.has(id)) return;
    const want = id === cur ? '' : 'none'; if (el.style.display !== want) el.style.display = want;
    if (id !== cur) return;
    const im = el.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager';   // sichtbares Bild sofort laden
    if (el.parentElement.firstElementChild !== el) { el.parentElement.prepend(el); moved = true; }
  });
  if (cur === stackCur && !moved) return;   // Klick des Kunden auf ein anderes Galeriebild nicht überschreiben
  stackCur = cur;
  gal.querySelectorAll('[data-media-id]').forEach(el => el.classList.toggle('is-active', el.dataset.mediaId.split('-').pop() === cur));
  gal.querySelectorAll('[data-target]').forEach(el => { const b = el.querySelector('button'); if (b) { if (el.dataset.target.split('-').pop() === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); } });
  gal.querySelectorAll('slider-component').forEach(sl => { try { if (sl.resetPages) sl.resetPages(); else if (sl.initPages) sl.initPages(); } catch (_) {} });
  gal.querySelectorAll('ul').forEach(u => { if (u.scrollLeft) u.scrollLeft = 0; });
}

// ------------------------------------------------------------ Geld (Format aus {{ 1234567 | money }} des Shops)
const rate = cfg.fx ? parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '') : 1;
const money = (() => {
  const s = String(cfg.fmt).trim(), i = s.search(/\d/);
  let j = s.length - 1; while (j >= 0 && !/\d/.test(s.charAt(j))) j--;
  const pre = s.slice(0, i), suf = s.slice(j + 1), core = s.slice(i, j + 1);
  const dec = /\D\d{2}$/.test(core) ? core.charAt(core.length - 3) : '';
  const thou = (dec ? core.slice(0, -3) : core).replace(/\d/g, '').charAt(0);
  return (c, short) => {
    c = Math.round(c);
    const whole = dec ? Math.floor(c / 100) : Math.round(c / 100);
    const cents = dec && !(short && c % 100 === 0) ? dec + ('0' + (c % 100)).slice(-2) : '';
    return pre + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thou) + cents + suf;
  };
})();

// ------------------------------------------------------------ Variante / Theme-Picker (Teil 1)
function variantInput() {
  return sec.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
}
function mainVariant() {
  const inp = variantInput(), id = inp ? String(inp.value) : new URLSearchParams(location.search).get('variant');
  return variants.find(x => String(x.id) === String(id)) || variants[0];
}
function themeOption(name) {
  return [...sec.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select')]
    .filter(el => el.name.replace(/^options\[(.*)\]$/, '$1') === name);
}
function hideSizeOption() {   // ② ersetzt die Größe im Theme-Picker (das Theme zeichnet den Picker evtl. neu)
  if (PER) sec.querySelectorAll('variant-selects, variant-radios').forEach(v => v.classList.add('sb-hidden-option'));   // „hybrid“: ganz
  if (sizeIdx < 0) return;
  themeOption(cfg.sizeOption).forEach(el => { const fs = el.closest('fieldset') || el.parentElement; if (fs && !fs.classList.contains('sb-hidden-option')) fs.classList.add('sb-hidden-option'); });
}
function chooseOpt(idx, val) {   // Option idx der Theme-Variante setzen (Radio/Select des Theme-Pickers, sonst direkt im Formular)
  const els = themeOption(cfg.options[idx]), r = els.find(el => el.type === 'radio' && el.value === val), sel = els.find(el => el.tagName === 'SELECT');
  if (r) { if (!r.checked) r.click(); }
  else if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', {bubbles: true})); }
  else {   // kein Theme-Picker gefunden: Variante direkt im Formular setzen
    const cur = mainVariant(), v = variants.find(x => x.options.every((o, k) => k === idx ? o === val : o === cur.options[k])), inp = variantInput();
    if (v && inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', {bubbles: true})); }
  }
  setTimeout(sync, 30);
}
const chooseSize = val => chooseOpt(sizeIdx, val);

// ------------------------------------------------------------ Namen (erlaubt: Buchstaben, Ziffern, . , ' ’ & - und ♥)
const HEART_EMOJI = /[❣❤\u{1F493}-\u{1F49F}\u{1F5A4}\u{1F90D}\u{1F90E}\u{1F9E1}\u{1FA75}-\u{1FA77}]\uFE0F?/gu;
const SYMS = [...(cfg.symbols || '♥')].filter(c => c.trim());
const okChar = ch => /[\p{L}\p{M}\p{N} .,'’&\-]/u.test(ch) || SYMS.includes(ch);
const len = s => [...s].length;
function clean(raw) {
  let out = '', dropped = false;
  for (const ch of raw.replace(HEART_EMOJI, SYMS.includes('♥') ? '♥' : '').replace(/\uFE0F/g, '')) { if (okChar(ch)) out += ch; else dropped = true; }
  return {text: [...out].slice(0, cfg.max).join(''), dropped};
}
const partEl = i => root.querySelector(`[data-be-part="${i}"]`);
function setName(i, inp) {
  const {text, dropped} = clean(inp.value);
  if (text !== inp.value) {
    const pos = Math.max(0, (inp.selectionStart || text.length) - (len(inp.value) - len(text)));
    inp.value = text;
    try { inp.setSelectionRange(pos, pos); } catch (_) {}
  }
  const p = state.parts[i]; p.name = text;
  const box = partEl(i), c = box && box.querySelector('[data-be-cnt]'); if (c) c.textContent = `${len(text)}/${cfg.max}`;
  if (p.err && (text.trim() || p.err === T.onlyChars)) setError(i, '');
  if (dropped) {   // Hinweis kurz zeigen: in ③ statt der Hilfezeile, in den Karten unter dem Feld
    const h = box && box.querySelector('[data-be-hint]');
    if (h) {
      if (!h.dataset.base) h.dataset.base = h.textContent;
      clearTimeout(h._t); h.textContent = T.onlyChars; h.className = 'sb-error';
      h._t = setTimeout(() => { h.textContent = h.dataset.base; h.className = 'sb-hint'; }, 3500);
    } else { setError(i, T.onlyChars); setTimeout(() => { if (p.err === T.onlyChars) setError(i, ''); }, 3500); }
  }
  if (i > 0) renderSum(i);
  drawAll();
}
function setFont(i, f) {
  state.parts[i].font = f; state.lastFont = f;
  const box = partEl(i); if (!box) return;
  box.dataset.sbFont = f;
  box.querySelectorAll('[data-font]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.font === f)));
  drawAll();
}
const fontOf = i => state.parts[i].font || state.lastFont;
function setFontAll(f) {   // Modus „anzahl“: eine Schrift für alle Teile
  state.parts.forEach(p => { p.font = f; }); state.lastFont = f;
  if (fieldsBox) fieldsBox.dataset.sbFont = f;
  root.querySelectorAll('[data-be-fontall] [data-font]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.font === f)));
}
// Fehler direkt am Feld (STYLEGUIDE §4.9): Rahmen rot + Text darunter
function setError(i, msg) {
  state.parts[i].err = msg;
  const box = partEl(i); if (!box) return;
  const inp = box.querySelector('[data-be-name]'), field = box.querySelector('.sb-field');
  if (inp) inp.classList.toggle('is-error', !!msg && msg !== T.onlyChars);
  let e = box.querySelector('[data-be-err]');
  if (msg && !e) { e = document.createElement('p'); e.className = 'sb-error'; e.dataset.beErr = ''; field.insertAdjacentElement('afterend', e); }
  if (e) { if (msg) e.textContent = msg; else e.remove(); }
  if (i > 0) renderSum(i);
}

// ------------------------------------------------------------ Gravierbare Symbole (wie Augen-Armband, STYLEGUIDE §4.5 sb-sym)
const HEART = 'M12 20.5C11 19.6 3 14.4 3 8.9 3 6 5.2 4 7.7 4c1.8 0 3.3 1 4.3 2.5C13 5 14.5 4 16.3 4 18.8 4 21 6 21 8.9c0 5.5-8 10.7-9 11.6Z';
const STAR = 'M12 2.8L14.53 9.32L21.51 9.71L16.09 14.13L17.88 20.89L12 17.1L6.12 20.89L7.91 14.13L2.49 9.71L9.47 9.32Z';
const SYMBOL_ICONS = {
  '♥': {d: HEART}, '♡': {d: HEART, sw: 2},
  '∞': {d: 'M12 12c-1.8-2.4-3.4-4-5.5-4a4 4 0 0 0 0 8c2.1 0 3.7-1.6 5.5-4Zm0 0c1.8 2.4 3.4 4 5.5 4a4 4 0 0 0 0-8c-2.1 0-3.7 1.6-5.5 4Z', sw: 2.1},
  '★': {d: STAR}, '☆': {d: STAR, sw: 1.8},
  '☾': {d: 'M12 3A9 9 0 1 0 20.44 15.13A7.4 7.4 0 0 1 12 3Z'},
  '✿': {d: 'M15.9 7.4a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM20.66 10.85a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM18.84 16.45a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM12.96 16.45a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM11.14 10.85a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0Z'},
  '♪': {d: 'M11.5 17.3a2.8 2.8 0 1 1-5.6 0a2.8 2.8 0 1 1 5.6 0ZM10.2 17.3V3.5h1.8v13.8ZM12 3.5c.6 2.6 2.4 3.6 4.2 4.6 1.6.9 2.1 2.8 1.2 4.6.3-1.6-.6-2.7-2-3.3-1.3-.6-2.6-1.2-3.4-2.2Z'},
  '†': {d: 'M10.9 2.5h2.2v5.2h4.6v2.2h-4.6v11.6h-2.2V9.9H6.3V7.7h4.6Z'},
  '✦': {d: 'M12 3.3c.9 5.3 3.4 7.8 8.7 8.7-5.3.9-7.8 3.4-8.7 8.7-.9-5.3-3.4-7.8-8.7-8.7 5.3-.9 7.8-3.4 8.7-8.7Z'},
};
const symIcon = ch => { const s = SYMBOL_ICONS[ch]; return s
  ? `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${s.d}" ${s.sw ? `fill="none" stroke="currentColor" stroke-width="${s.sw}" stroke-linejoin="round" stroke-linecap="round"` : 'fill="currentColor"'}/></svg>`
  : `<span aria-hidden="true" style="font-size:20px">${esc(ch)}</span>`; };
const SYM_BTN = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="9" cy="10" r="1.2" fill="currentColor"/><circle cx="15" cy="10" r="1.2" fill="currentColor"/><path d="M8.3 14.2c.9 1.4 2.2 2.1 3.7 2.1s2.8-.7 3.7-2.1" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
let symPop = null, symFor = -1;
function closeSym() {
  if (symPop) symPop.remove();
  symPop = null; symFor = -1;
  root.querySelectorAll('[data-be-sym]').forEach(b => b.setAttribute('aria-expanded', 'false'));
}
function openSym(i, btn) {
  closeSym(); symFor = i;
  symPop = document.createElement('div');
  symPop.className = 'sb-sympop'; symPop.setAttribute('role', 'group'); symPop.setAttribute('aria-label', T.symLabel);
  symPop.innerHTML = SYMS.map(c => `<button type="button" data-be-symch="${esc(c)}" aria-label="${esc(c)}">${symIcon(c)}</button>`).join('');
  symPop.addEventListener('pointerdown', e => e.preventDefault());   // Handy-Tastatur bleibt offen
  btn.closest('.sb-field').after(symPop);
  btn.setAttribute('aria-expanded', 'true');
}
function insertSym(i, ch) {
  const inp = partEl(i) && partEl(i).querySelector('[data-be-name]'); if (!inp) return;
  if (len(inp.value) >= cfg.max) return;
  const a = inp.selectionStart != null ? inp.selectionStart : inp.value.length, z = inp.selectionEnd != null ? inp.selectionEnd : a;
  inp.value = inp.value.slice(0, a) + ch + inp.value.slice(z);
  try { inp.setSelectionRange(a + ch.length, a + ch.length); } catch (_) {}
  setName(i, inp);
}
document.addEventListener('click', e => { if (symPop && !e.target.closest('.sb-sympop, [data-be-sym], [data-be-name]')) closeSym(); });

// ------------------------------------------------------------ ④ Karten je weiterem Teil (sb-part, §4.10)
function rowHTML(i) {   // Farbe (Shopify-Swatches) + übrige Optionen als Dropdown
  const row = values.map((vals, k) => {
    if (vals.length < 2) return '';
    if (k === colorIdx) return `<div class="sb-swatches" role="radiogroup" aria-label="${esc(cfg.options[k])}">${vals.map(v => {
      const a = swatchAttr(v);
      return `<button type="button" class="sb-swatch${a.cls}" style="${esc(a.style)}" role="radio" aria-checked="false" aria-label="${esc(v)}" title="${esc(v)}" data-be-opt="${i}:${k}" data-val="${esc(v)}"></button>`;
    }).join('')}</div>`;
    return `<label class="sb-dd"><select data-be-opt="${i}:${k}" aria-label="${esc(cfg.options[k])}">${vals.map(v =>
      `<option value="${esc(v)}">${esc(k === sizeIdx ? cfg.options[k] + ' ' + v : v)}</option>`).join('')}</select></label>`;
  }).join('');
  const eye = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
  const pv = !(PVBTN && PV) ? '' : PVHOLD   // „halten“: zweite Zeile „Gedrückt halten“ unter „Vorschau“
    ? `<button type="button" class="sb-tile sb-pvbtn sb-pvbtn--hold" data-be-pvbtn aria-pressed="false"><span class="sb-pvbtn-main">${eye}${esc(T.preview)}</span><span class="sb-pvbtn-sub">${esc(T.previewHold)}</span></button>`
    : `<button type="button" class="sb-tile sb-pvbtn" data-be-pvbtn aria-pressed="false">${eye}${esc(T.preview)}</button>`;
  return row || pv ? `<div class="sb-part-row">${row}${pv}</div>` : '';
}
// Knopf „Vorschau“: die Vorschau schwebt als Karte über dem Namensfeld (sb-pvpop, nicht im Seitenfluss) – Öffnen/Schließen verschiebt
// nichts. Höchstens eine offen (i = -1 schließt alle); ein anderer Ring oder ein Tipp daneben schließt sie.
function openPv(i) {
  root.querySelectorAll('[data-be-fields] [data-be-part]').forEach(el => {
    const w = el.querySelector('[data-be-pv]'); if (!w) return;
    const on = +el.dataset.bePart === i; w.hidden = !on;
    const b = el.querySelector('[data-be-pvbtn]'); if (b) b.setAttribute('aria-pressed', String(on));
  });
  drawAll();
}
const pvOpen = () => { const w = root.querySelector('[data-be-fields] [data-be-pv]:not([hidden])'); return w ? +w.closest('[data-be-part]').dataset.bePart : -1; };
const togglePv = i => openPv(pvOpen() === i ? -1 : i);
function partHTML(i) {
  const row = rowHTML(i), multiFont = Object.keys(FONTS).length > 1;
  return `<div class="sb-part" data-be-part="${i}" data-sb-font="${fontOf(i)}" hidden>
    ${MODE === 'plus' ? `<button type="button" class="sb-part-x" data-be-remove="${i}" aria-label="${esc(fmt(T.remove, {...U, unit: U1 + ' ' + (i + 1)}))}">×</button>` : ''}
    <button type="button" class="sb-part-head" aria-expanded="false" data-be-open="${i}"><span class="sb-part-title">${esc(U1)} ${i + 1}</span><span class="sb-part-sum" data-be-sum></span></button>
    <div class="sb-part-body" hidden>
      ${row}
      <label class="sb-field"><span>${esc(T.nameOrWord)} <em data-be-cnt>0/${cfg.max}</em></span><span class="sb-inwrap"><input class="sb-input" type="text" data-be-name maxlength="${cfg.max}" placeholder="${esc(T.placeholder)}" autocomplete="off" autocapitalize="words" spellcheck="false" enterkeyhint="done">${SYMS.length ? `<button type="button" class="sb-symbtn" data-be-sym aria-label="${esc(T.symBtn)}" aria-expanded="false">${SYM_BTN}</button>` : ''}</span></label>
      ${multiFont ? `<div class="sb-font" role="radiogroup" aria-label="${esc(T.font)}">${Object.keys(FONTS).map(k =>
        `<button type="button" class="sb-tile" role="radio" aria-checked="${k === fontOf(i)}" data-font="${k}">${esc(FONTS[k])}</button>`).join('')}</div>` : ''}
      ${PV ? '<div class="sb-preview" style="aspect-ratio:5/3;margin-top:12px" data-be-pv hidden><canvas></canvas></div>' : ''}
    </div>
  </div>`;
}
function buildParts() {
  if (PER && fieldsBox) {   // „hybrid“: Farbe/Größe direkt unter jedes Feld (Teil 1 stellt den ausgeblendeten Theme-Picker)
    fieldsBox.querySelectorAll('[data-be-part]').forEach(el => {
      const f = el.querySelector('.sb-field'); if (!f) return;
      f.insertAdjacentHTML('afterend', rowHTML(+el.dataset.bePart));
      const pvHTML = cls => `<div class="sb-preview${cls}" style="aspect-ratio:4/1${cls ? '' : ';margin:0 0 12px'}" data-be-pv hidden><canvas aria-label="${esc(T.previewOf)}"></canvas></div>`;
      const iw = f.querySelector('.sb-inwrap');
      if (PVHOLD && PV) el.querySelector('.sb-part-row').insertAdjacentHTML('afterend', pvHTML(''));   // „halten“: unter der Zeile
      else if (PVBTN && PV && iw) iw.insertAdjacentHTML('beforeend', pvHTML(' sb-pvpop'));   // schwebt über dem Feld (beim Tippen sichtbar)
    });
    return;
  }
  if (!partsBox || maxQty < 2) return;
  let html = '';
  for (let i = 1; i < maxQty; i++) html += partHTML(i);
  partsBox.innerHTML = html;
}
function renderPart(i) {
  const p = state.parts[i];
  root.querySelectorAll(`[data-be-opt^="${i}:"]`).forEach(el => {
    const k = +el.dataset.beOpt.split(':')[1];
    if (el.tagName === 'SELECT') el.value = p.opts[k];
    else el.setAttribute('aria-checked', String(el.dataset.val === p.opts[k]));
  });
  renderSum(i);
}
function fillPart(i) {
  const box = partEl(i), p = state.parts[i]; if (!box) return;
  const inp = box.querySelector('[data-be-name]'); inp.value = p.name;
  box.querySelector('[data-be-cnt]').textContent = `${len(p.name)}/${cfg.max}`;
  if (p.font) setFont(i, p.font); else { box.dataset.sbFont = state.lastFont; box.querySelectorAll('[data-font]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.font === state.lastFont))); }
  setError(i, p.err);
  if (p.opts) renderPart(i);
}
function removePart(i) {
  if (i < 1 || i >= state.qty) return;
  closeSym();
  const keepFont = state.lastFont;
  state.parts.splice(i, 1);
  state.parts.push({name: '', font: null, opts: null, touched: false, err: ''});
  for (let j = i; j < state.parts.length; j++) fillPart(j);
  state.lastFont = keepFont;
  setQty(state.qty - 1);
  openPart(-1);
  drawAll();
}
function renderSum(i) {
  const box = partEl(i), el = box && box.querySelector('[data-be-sum]'); if (!el) return;
  const p = state.parts[i], o = (p.opts || []).filter((_, k) => values[k].length > 1);
  el.textContent = [...o, p.name.trim() || T.enterName].join(' · ');
  el.classList.toggle('is-error', !!p.err && p.err !== T.onlyChars);
}
function openPart(i) {   // immer nur eine Karte offen; i = -1 schließt alle
  state.open = i;
  root.querySelectorAll('.sb-part').forEach(el => {
    const on = +el.dataset.bePart === i;
    el.classList.toggle('is-open', on);
    el.querySelector('.sb-part-body').hidden = !on;
    el.querySelector('.sb-part-head').setAttribute('aria-expanded', String(on));
  });
}
function follow(i, v) {   // Optionen, die der Kunde in diesem Teil nicht selbst gewählt hat, folgen Teil 1
  const p = state.parts[i], own = p.own || {};
  p.opts = v.options.map((o, k) => own[k] && p.opts ? p.opts[k] : o);
  renderPart(i);
}
function firstEmpty(from = 1) { for (let i = from; i < state.qty; i++) if (!state.parts[i].name.trim()) return i; return -1; }
function setQty(q) {
  const prev = state.qty; state.qty = q;
  root.querySelectorAll('[data-be-qty]').forEach(t => {
    const on = +t.dataset.beQty === q;
    t.classList.toggle('is-active', on); t.setAttribute('aria-checked', String(on));
  });
  if (partsBox) {
    partsBox.hidden = q < 2;
    const v = mainVariant();
    partsBox.querySelectorAll('[data-be-part]').forEach(el => {
      const i = +el.dataset.bePart, p = state.parts[i]; el.hidden = i >= q;
      if (i < q && v) follow(i, v);   // Vorbelegung wie Teil 1
      if (i < q && !p.font) setFont(i, state.lastFont);
    });
    if (q > prev) {   // neue Stufe / neuer Ring: Anpassung klappt sofort auf
      const e = firstEmpty();
      openPart(MODE === 'plus' ? q - 1 : e > 0 ? e : q - 1);
    }
    else if (state.open >= q) openPart(-1);
  }
  if (fieldsBox) {   // Modus „anzahl“: so viele Felder wie Teile, „Fertig“ erst im letzten
    fieldsBox.querySelectorAll('[data-be-part]').forEach(el => {
      const i = +el.dataset.bePart; el.hidden = i >= q;
      const inp = el.querySelector('[data-be-name]'); if (inp) inp.setAttribute('enterkeyhint', i < q - 1 ? 'next' : 'done');
    });
    if (gTitle) gTitle.textContent = q > 1 ? T.gravurMany : T.gravurOne;
    if (q < prev) closeSym();
  }
  for (let i = q; i < state.parts.length; i++) if (state.parts[i].err) setError(i, '');
  renderNudge();
  renderHeadPrice();
  showStack();
  drawAll();
}

// ------------------------------------------------------------ Preise je Stufe (Stückpreis × n − Rabatt × Kurs, wie der Warenkorb)
let totals = {};
function renderPrices() {
  if (!bundle) return;
  const v = mainVariant();
  if (!v || !(rate > 0)) { bundle.hidden = true; return; }
  const c1 = Math.max(v.cmp || 0, v.price);
  let prev = v.price, ok = true; totals = {1: {tot: v.price, cmp: c1}};
  tiers.forEach(t => {
    const tot = t.qty * v.price - Math.round(t.disc * rate), cmp = t.qty * c1;
    if (!(tot > prev && tot < t.qty * v.price)) ok = false;
    totals[t.qty] = {tot, cmp, add: tot - prev}; prev = tot;
  });
  root.querySelectorAll('[data-be-qty]').forEach(el => {   // Modus „stufen“ (in „anzahl“ tragen die Kacheln nur die Zahl)
    const r = totals[+el.dataset.beQty], pe = el.querySelector('[data-be-price]'); if (!r || !pe) return;
    pe.textContent = money(r.tot);
    const s = el.querySelector('[data-be-cmp]'); s.textContent = money(r.cmp); s.hidden = !(r.cmp > r.tot);
    const sv = el.querySelector('[data-be-save]'); if (sv) sv.textContent = fmt(T.save, {n: Math.round((r.cmp - r.tot) * 100 / r.cmp)});
  });
  bundle.hidden = !ok;   // nie einen falschen Preis zeigen
  if (!ok && state.qty > 1) setQty(1);
  renderNudge();
  renderHeadPrice();
}
// Modus „anzahl“: Set-Preis, Vergleichspreis und „Spare xx %“ im Theme-Preis oben – wie eine Varianten-Option (SB200).
// Das Theme zeichnet den Preis bei jedem Variantenwechsel neu, daher bei jedem sync erneut (schreibt nur, wenn der Text abweicht).
function renderHeadPrice() {
  if (MODE !== 'anzahl') return;
  const r = totals[state.qty], box = sec.querySelector('[id^="price-"] .price'); if (!r || !box) return;
  const put = (sel, txt) => box.querySelectorAll(sel).forEach(el => { if (el.textContent.trim() !== txt) el.textContent = txt; });
  put('.price-item--sale', money(r.tot));
  put('.price__regular .price-item--regular', money(r.tot));
  put('.price__sale s.price-item--regular', money(r.cmp));
  const b = box.querySelector('.price__badge-sale');
  if (b && r.cmp > r.tot) { const t = b.textContent.replace(/\d+(?=\s*%)/, Math.round((r.cmp - r.tot) * 100 / r.cmp)); if (t !== b.textContent) b.textContent = t; }
}
function renderNudge() {   // Anreiz-Zeile (+ im Modus „plus“ der Knopf mit dem Preis des nächsten Rings)
  if (!nudge || !totals[1]) return;
  const cur = totals[state.qty], next = tiers.find(t => t.qty > state.qty), nx = next && totals[next.qty], out = [];
  if (MODE === 'plus') {
    if (addBtn) {   // Hinzufügen-Kachel: durchgestrichener Stückpreis + Preis des nächsten Teils, sonst nichts
      addBtn.hidden = !nx;
      if (nx) {
        addBtn.querySelector('[data-be-addprice]').textContent = '+' + money(nx.add, true);
        const cm = addBtn.querySelector('[data-be-addcmp]'); if (cm) { cm.textContent = money(totals[1].tot); cm.hidden = !(totals[1].tot > nx.add); }
      }
    }
    if (!nx) out.push(fmt(T.max, {...U, n: state.qty}));
  } else {
    if (state.qty > 1 && cur && cur.cmp > cur.tot) out.push(fmt(T.youSave, {price: money(cur.cmp - cur.tot)}));
    if (nx) out.push(fmt(T.extra, {...U, n: next.qty, price: money(nx.add, true)}));
  }
  nudge.textContent = out.join(' · ');
}

// ------------------------------------------------------------ Abgleich mit dem Theme (Teil 1)
let lastId = null;
function sync() {
  hideSizeOption();
  renderHeadPrice();
  showStack();
  const v = mainVariant(); if (!v || String(v.id) === lastId) return;
  lastId = String(v.id);
  state.parts[0].opts = v.options.slice();
  if (PER) renderPart(0);   // Zeile von Teil 1 = Theme-Variante
  if (sizeIdx >= 0) root.querySelectorAll('[data-be-size]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.beSize === v.options[sizeIdx])));
  for (let i = 1; i < state.parts.length; i++) follow(i, v);   // Teile ohne eigene Wahl folgen Teil 1
  renderPrices();
  drawAll();
}

// ------------------------------------------------------------ Prüfen vor dem Warenkorb
const partVariant = i => i === 0 || (MODE === 'anzahl' && !PER) ? mainVariant() : findVariant(state.parts[i].opts);   // „anzahl“: alle wie Teil 1
function problem() {
  for (let i = 0; i < state.qty; i++) {
    if (!state.parts[i].name.trim()) return {i, msg: T.errName};
    const v = partVariant(i);
    if (!v || !v.ok) return {i, msg: T.errNA};
  }
  return null;
}
function showProblem(p) {
  if (p.i > 0) openPart(p.i);
  setError(p.i, p.msg);
  const inp = partEl(p.i) && partEl(p.i).querySelector('[data-be-name]');
  if (inp) { inp.scrollIntoView({block: 'center', behavior: 'smooth'}); setTimeout(() => inp.focus({preventScroll: true}), 350); }
  root.classList.remove('is-shake'); void root.offsetWidth; root.classList.add('is-shake');
}

// ------------------------------------------------------------ Ereignisse
function pickOpt(el, val) {
  const [i, k] = el.dataset.beOpt.split(':').map(Number), p = state.parts[i];
  if (i === 0) { chooseOpt(k, val); return; }   // Teil 1 = Theme-Variante: Picker oben bzw. ausgeblendete Option mitstellen
  p.opts[k] = val; p.touched = true; (p.own = p.own || {})[k] = true;
  if (p.err === T.errNA) setError(i, '');
  renderPart(i);
  drawAll();
}
root.addEventListener('pointerdown', e => { if (e.target.closest('[data-be-sym]')) e.preventDefault(); });
root.addEventListener('input', e => { const n = e.target.closest('[data-be-name]'); if (n) setName(+n.closest('[data-be-part]').dataset.bePart, n); });
function closePvOutside(e) {   // Tipp/Fokus außerhalb des Rings mit offener Vorschau schließt sie (der eigene Preview-Knopf schaltet selbst)
  const o = PVBTN && !PVHOLD ? pvOpen() : -1; if (o < 0 || e.target.closest('[data-be-pvbtn]')) return;
  const pe = e.target.closest && e.target.closest('[data-be-fields] [data-be-part]');
  if (!pe || +pe.dataset.bePart !== o) openPv(-1);
}
document.addEventListener('click', closePvOutside);
root.addEventListener('focusin', closePvOutside);
// vorschau: 'halten' – gedrückt halten zeigt die Vorschau unter der Zeile, Loslassen blendet sie aus. Ein kurzer Tipp (< 250 ms)
// zeigt sie 1,5 s lang, damit ein normaler Tipp nicht ins Leere geht. Tastatur: Leertaste/Enter halten.
let holdT0 = 0, holdTimer = 0;
function holdStart(btn) { clearTimeout(holdTimer); holdT0 = Date.now(); openPv(+btn.closest('[data-be-part]').dataset.bePart); }
function holdEnd() {
  if (!holdT0) return;
  const quick = Date.now() - holdT0 < 250; holdT0 = 0;
  clearTimeout(holdTimer); holdTimer = setTimeout(() => openPv(-1), quick ? 1500 : 0);
}
if (PVHOLD) {
  root.addEventListener('pointerdown', e => {
    const b = e.target.closest('[data-be-pvbtn]'); if (!b || e.button > 0) return;
    e.preventDefault(); try { b.setPointerCapture(e.pointerId); } catch (_) {}
    holdStart(b);
  });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => root.addEventListener(t, e => { if (e.target.closest && e.target.closest('[data-be-pvbtn]')) holdEnd(); }));
  root.addEventListener('contextmenu', e => { if (e.target.closest('[data-be-pvbtn]')) e.preventDefault(); });   // Android: kein Menü beim Halten
  root.addEventListener('keydown', e => { const b = e.target.closest('[data-be-pvbtn]'); if (b && (e.key === ' ' || e.key === 'Enter')) { e.preventDefault(); if (!e.repeat) holdStart(b); } });
  root.addEventListener('keyup', e => { if (e.target.closest('[data-be-pvbtn]') && (e.key === ' ' || e.key === 'Enter')) holdEnd(); });
}
// Größentabelle („hybrid“): Link im Schritt-Kopf öffnet den Dialog; ✕ oder Tipp auf den Hintergrund schließt ihn
const sgDlg = root.querySelector('[data-be-sgdlg]');
if (sgDlg && sgDlg.showModal) {
  root.querySelector('[data-be-sg]').addEventListener('click', () => { sgDlg.showModal(); document.documentElement.style.overflow = 'hidden'; });
  sgDlg.addEventListener('click', e => { if (e.target === sgDlg || e.target.closest('[data-be-sgx]')) sgDlg.close(); });
  sgDlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
} else if (sgDlg) root.querySelector('[data-be-sg]').hidden = true;
root.addEventListener('change', e => { const s = e.target.closest('select[data-be-opt]'); if (s) pickOpt(s, s.value); });
root.addEventListener('click', e => {
  const sb = e.target.closest('[data-be-sym]');
  if (sb) { e.preventDefault(); const i = +sb.closest('[data-be-part]').dataset.bePart; symFor === i ? closeSym() : openSym(i, sb); return; }
  const sc = e.target.closest('[data-be-symch]'); if (sc) { insertSym(symFor, sc.dataset.beSymch); return; }
  const q = e.target.closest('[data-be-qty]'); if (q) { setQty(+q.dataset.beQty); return; }
  const pb = e.target.closest('[data-be-pvbtn]'); if (pb) { if (!PVHOLD) togglePv(+pb.closest('[data-be-part]').dataset.bePart); return; }
  if (e.target.closest('[data-be-add]')) { if (state.qty < maxQty) setQty(state.qty + 1); return; }
  const x = e.target.closest('[data-be-remove]'); if (x) { removePart(+x.dataset.beRemove); return; }
  const s = e.target.closest('[data-be-size]'); if (s) { chooseSize(s.dataset.beSize); return; }
  const h = e.target.closest('[data-be-open]'); if (h) { const i = +h.dataset.beOpen; openPart(state.open === i ? -1 : i); return; }
  const o = e.target.closest('button[data-be-opt]'); if (o) { pickOpt(o, o.dataset.val); return; }
  const f = e.target.closest('[data-font]');
  if (f) { const pe = f.closest('[data-be-part]'); if (pe) setFont(+pe.dataset.bePart, f.dataset.font); else setFontAll(f.dataset.font); }
});
root.addEventListener('keydown', e => {
  const n = e.target.closest('[data-be-name]');
  if (n && e.key === 'Enter') {   // „Fertig“ auf der Tastatur: nächste Karte ohne Namen öffnen
    e.preventDefault();
    const i = +n.closest('[data-be-part]').dataset.bePart;
    if (MODE === 'anzahl') { const nf = i + 1 < state.qty && partEl(i + 1); if (nf) nf.querySelector('[data-be-name]').focus(); else e.target.blur(); return; }
    e.target.blur();
    const after = firstEmpty(i + 1), nx = after > 0 ? after : firstEmpty();
    if (i > 0 || nx > 0) openPart(nx);
    return;
  }
  const r = e.target.closest('[role="radio"]');   // Pfeiltasten in den Auswahlgruppen
  if (r && /^Arrow(Left|Right|Up|Down)$/.test(e.key)) {
    const all = [...r.parentElement.querySelectorAll('[role="radio"]')], d = /Right|Down/.test(e.key) ? 1 : -1;
    const nb = all[(all.indexOf(r) + d + all.length) % all.length]; e.preventDefault(); nb.focus(); nb.click();
  }
});

// ------------------------------------------------------------ Warenkorb-Einhängen (Theme schickt FormData an /cart/add)
function variantOf(body) {
  try {
    if (body instanceof FormData || body instanceof URLSearchParams) return String(body.get('id') || '');
    if (typeof body === 'string') {
      try { const j = JSON.parse(body); return String(j.id || (j.items && j.items[0] && j.items[0].id) || ''); }
      catch (_) { return String(new URLSearchParams(body).get('id') || ''); }
    }
  } catch (_) {}
  return '';
}
function withProps(body, props) {
  const put = b => Object.keys(props).forEach(k => b.set(`properties[${k}]`, props[k]));
  if (body instanceof FormData || body instanceof URLSearchParams) { put(body); return body; }
  if (typeof body === 'string') {
    try {
      const j = JSON.parse(body), it = Array.isArray(j.items) ? j.items.find(x => ids.has(String(x.id))) : j;
      if (it) it.properties = Object.assign({}, it.properties, props);
      return JSON.stringify(j);
    } catch (_) { const u = new URLSearchParams(body); put(u); return u.toString(); }
  }
  return body;
}
const propsOf = i => ({[P.name]: state.parts[i].name.trim(), [P.font]: FONTS[fontOf(i)]});
const fake422 = msg => new Response(JSON.stringify({status: 422, message: 'Cart Error', description: msg}), {status: 422, headers: {'Content-Type': 'application/json'}});
async function addExtras() {
  if (state.qty < 2) return [];
  const items = [];
  for (let i = 1; i < state.qty; i++) items.push({id: partVariant(i).id, quantity: 1, properties: propsOf(i)});
  const res = await origFetch(cfg.cartAddUrl + '.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
  if (!res.ok) throw new Error('extras ' + res.status);
  const j = await res.json().catch(() => ({}));
  return (j.items || []).map(x => x.key).filter(Boolean);
}
async function dropExtras(keys) {
  for (const id of keys || []) await origFetch(cfg.cartAddUrl.replace(/\/add$/, '/change') + '.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id, quantity: 0})}).catch(() => {});
}
window.fetch = function (input, init) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  if (!/\/cart\/add/.test(url) || !init || !init.body || !ids.has(variantOf(init.body))) return origFetch(input, init);
  const p = problem();
  if (p) { showProblem(p); return Promise.resolve(fake422(p.msg)); }
  return addExtras().then(keys => {
    const next = Object.assign({}, init, {body: withProps(init.body, propsOf(0))});
    return origFetch(input, next).then(res => { if (!res.ok) dropExtras(keys); return res; },
                                       e => { dropExtras(keys); throw e; });
  }, () => fake422(T.errCart));
};
const oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function (m, u) { this.__beUrl = String(u || ''); return oOpen.apply(this, arguments); };
XMLHttpRequest.prototype.send = function (body) {   // fremde Skripte per XHR: ohne Namen nicht in den Warenkorb
  if (/\/cart\/add/.test(this.__beUrl || '') && body && ids.has(variantOf(body))) {
    const p = problem(); if (p) { showProblem(p); return; }
  }
  return oSend.apply(this, arguments);
};

// ------------------------------------------------------------ Start
{ const p0 = partEl(0); state.parts[0].font = (p0 && p0.dataset.sbFont) || FONT0; }   // Teil 1: Vorauswahl aus dem Markup, erbt nichts
buildParts();
sync();
setQty(MODE === 'anzahl' && bundle && !bundle.hidden ? Math.min(maxQty, Math.max(1, cfg.start || 1)) : 1);
setInterval(sync, 400);   // Varianten-Wechsel des Themes (Farbe) – robust für alle alten Themes
document.addEventListener('change', () => setTimeout(sync, 30), true);
})();
